<section class="moratorium-wrap">
  <div class="wrap-lg">
    <div class="moratorium-inner">
      <div class="nav-sec">
        <div class="back-nav">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="nav-name" >Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">Want to opt for a moratorium?</div>
          <div class="page-info">Pay only interest for the loan amount during the moratorium period.</div>
        </div>
      </div>
      <div class="box-wrap">
        <div class="moratorium-list">
          <div class="moratorium-item " [ngClass]="{selected:isWithMoratoriumSelected}" (click)="isWithMoratoriumSelected = true" *ngIf="calcEmi">
            <div class="moratorium-title">
              <div class="option-dot"></div>
              EMI with Moratorium
            </div>
            <div class="moratorium-info">
              <div class="info-item">
                <div class="info-left">Pay <span class="value">₹{{calcEmi.emiBeforeMoratorium}}</span></div>
                <div class="info-right">for first <span class="value">{{moratoriumPeriod}} months</span></div>
              </div>
              <div class="info-item">
                <div class="info-left">then <span class="value">₹{{calcEmi.emi}}</span></div>
                <div class="info-right">for next <span class="value">{{selectedTenure?.selectedTenor.tenor - moratoriumPeriod}} months</span></div>
              </div>
            </div>
          </div>
          <div class="moratorium-item" [ngClass]="{selected:!isWithMoratoriumSelected}" (click)="isWithMoratoriumSelected = false" *ngIf="isWithoutMoratoriumOption">
            <div class="moratorium-title">
              <div class="option-dot"></div>
              EMI without Moratorium
            </div>
            <div class="moratorium-info">
              <div class="info-item">
                <div class="info-left">Pay <span class="value">₹{{selectedTenure?.emi}}</span></div>
                <div class="info-right">for <span class="value">{{selectedTenure?.selectedTenor.tenor}} months</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-action">
          <div class="action-info">By clicking "Continue", you’re agreeing to start your loan repayments after the moratorium period.</div>
          <button class="btn-primary" (click)="submit()">Continue</button>
        </div>
      </div>
    </div>
  </div>
</section>
